/* Pure Lab Nutrition — Diagnostic v2, theme-only. No external libraries. */
(() => {
  'use strict';

  const root = document.getElementById('pln-diagnostic');
  if (!root) return;

  const screen = document.getElementById('plnd-screen');
  const footer = document.getElementById('plnd-footer');
  const progress = document.getElementById('plnd-progress-bar');
  const stepLabel = document.getElementById('plnd-step-label');
  const currency = root.dataset.currency || 'EUR';

  const state = {
    index: 0,
    answers: {},
    products: [],
    recommended: [],
    selected: new Set(),
    email: '',
    previousFocus: null,
    name: '',
    goalSelection: [],
    path: []
  };

  const goals = [
    ['skin','✨','Ma peau'], ['hair','🌿','Mes cheveux et mes ongles'], ['immune','🛡️','Mon immunité'],
    ['weight','⚖️','Ma ligne'], ['digestion','🌱','Ma digestion'], ['joints','🦴','Mes os et articulations'],
    ['energy','⚡','Mon énergie'], ['stress','🍃','Mon stress'], ['sleep','🌙','Mon sommeil'],
    ['focus','🧠','Ma mémoire et mon activité cérébrale'], ['heart','❤️','Mon coeur, ma circulation et mon cholestérol'], ['sport','🏃','Mes capacités sportives'],
    ['beauty','☀️','Mon bronzage'], ['women','🌸','Mon confort féminin'], ['eyes','👁️','Ma vision et mes yeux'],
    ['hydration','💧','Mon hydratation']
  ];
  const o = (id, icon, label, note = '') => ({ id, icon, label, note });
  const Q = {
    name:{ title:'Commençons par vous connaître', subtitle:'Ces informations nous permettent de personnaliser vos recommandations.', type:'text'},
    age:{ title:'Quel est votre âge ?', subtitle:'Sélectionnez la tranche qui vous correspond.', options:[o('minor','👤','Moins de 18 ans'),o('18-25','👤','18 - 25 ans'),o('26-35','👤','26 - 35 ans'),o('36-45','👤','36 - 45 ans'),o('46-55','👤','46 - 55 ans'),o('56+','👤','56 ans et plus')] },
    sex:{ title:'Quel est votre genre ?', subtitle:'Cette information nous aide à afficher les questions les plus pertinentes.', options:[o('female','♀','Femme'),o('male','♂','Homme'),o('unspecified','○','Je préfère ne pas préciser')] },
    goals:{ title:'Quels sont vos objectifs ?', subtitle:'Choisissez jusqu’à 3 objectifs pour recevoir des recommandations personnalisées.', type:'multi', max:3, options:goals.map(x=>o(...x)) },

    sleep:{ title:'Mon sommeil', subtitle:'Niveau sommeil, quelle situation se rapproche le mieux de la vôtre ?', type:'multi', max:2, options:[
      o('fall','🌙','J’ai du mal à m’endormir'),
      o('night','⏰','Je me réveille souvent la nuit'),
      o('morning','☀️','Je me réveille tôt et je suis fatigué(e)'),
      o('good','✨','Mon sommeil est globalement bon')
    ]},
    women:{ title:'Mon confort féminin', subtitle:'Passons au confort féminin, que ressentez-vous ?', type:'multi', max:3, options:[
      o('premenstrual','🌸','Syndrome prémenstruel'),
      o('cramps','🫶','Douleurs au ventre (règles)'),
      o('period_fatigue','⚡','Fatigue liée aux règles'),
      o('uti','💧','Infections urinaires'),
      o('vaginal','🍃','Inconfort vaginal'),
      o('menopause_symptoms','🌼','Ménopause'),
      o('none','✓','Aucun inconfort particulier')
    ]},
    menopause:{ title:'Êtes-vous ménopausée ?', subtitle:'Cette information nous aide à affiner les recommandations en cas de confort féminin.', options:[o('yes','✓','Oui'),o('no','—','Non'),o('skip','○','Je préfère ne pas préciser')] },
    eyes:{ title:'Ma vision et mes yeux', subtitle:'Niveau vision, quelle(s) situation(s) se rapproche(nt) le mieux de la vôtre ?', type:'multi', max:3, options:[
      o('screens','💻','Fatigue visuelle liée aux écrans'),
      o('dry','👁️','Yeux secs ou irrités'),
      o('night','🌙','Vision moins confortable le soir'),
      o('general','🌿','Je veux soutenir ma vision au quotidien')
    ]},
    screen_time:{ title:'Combien de temps passez-vous sur les écrans par jour ?', subtitle:'Cela nous aide à mieux comprendre vos habitudes visuelles.', options:[o('low','📱','Moins de 2 heures'),o('medium','💻','2 à 4 heures'),o('high','🖥️','4 à 6 heures'),o('veryhigh','⌚','Plus de 6 heures')] },
    skin:{ title:'Ma peau', subtitle:'Quel est votre objectif principal pour votre peau ?', type:'multi', max:2, options:[o('hydration','💧','Hydratation'),o('glow','✨','Éclat'),o('elasticity','🌿','Élasticité / fermeté'),o('general','☀️','Beauté de la peau au quotidien')] },
    hair:{ title:'Mes cheveux et mes ongles', subtitle:'Que souhaitez-vous privilégier ?', type:'multi', max:2, options:[o('hair','🌿','Mes cheveux'),o('nails','✨','Mes ongles'),o('both','✓','Les deux')] },
    energy:{ title:'Mon énergie', subtitle:'Quelle situation se rapproche le plus de votre quotidien ?', options:[o('busy','⚡','J’ai besoin de plus d’énergie au quotidien'),o('uneven','📉','Mon énergie est irrégulière'),o('good','☀️','Je veux simplement soutenir ma vitalité')] },
    stress:{ title:'Mon stress', subtitle:'Quelle situation vous parle le plus ?', type:'multi', max:2, options:[o('occasional','🍃','Stress passager'),o('continuous','🧠','Stress fréquent'),o('mental','💭','Charge mentale importante'),o('sleep_link','🌙','Stress qui impacte mon sommeil')] },
    immune:{ title:'Mon immunité', subtitle:'Quelle est votre priorité ?', options:[o('daily','🛡️','Soutenir mon immunité au quotidien'),o('season','🍁','Mieux traverser les périodes saisonnières')] },
    digestion:{ title:'Ma digestion', subtitle:'Quelle est votre priorité digestive ?', options:[o('comfort','🌱','Confort digestif'),o('fibres','🥗','Apport en fibres'),o('balance','🍃','Équilibre alimentaire')] },
    joints:{ title:'Mes os et mes articulations', subtitle:'Quel est votre objectif ?', options:[o('daily','🦴','Confort articulaire au quotidien'),o('mobility','🏃','Accompagner une vie active')] },
    weight:{ title:'Ma ligne', subtitle:'Quel est votre état d’esprit actuel ?', options:[o('balanced','🥗','Équilibrer mon alimentation'),o('activity','🏃','Soutenir mes efforts avec le sport'),o('both','✓','Les deux')] },
    focus:{ title:'Ma mémoire et mon activité cérébrale', subtitle:'Quel aspect souhaitez-vous soutenir ?', options:[o('focus','🧠','Concentration'),o('memory','📚','Mémoire'),o('clarity','💡','Clarté mentale au quotidien')] },
    heart:{ title:'Mon coeur, ma circulation et mon cholestérol', subtitle:'Quelle est votre priorité ?', options:[o('circulation','❤️','Confort circulatoire'),o('cholesterol','🫀','Équilibre cardiovasculaire'),o('daily','🍃','Soutien quotidien')] },
    sport:{ title:'Mes capacités sportives', subtitle:'À quelle fréquence faites-vous du sport ?', options:[o('rare','🚶','Occasionnellement'),o('regular','🚴','2 à 3 fois par semaine'),o('high','🏋️','4 fois ou plus par semaine')] },
    beauty:{ title:'Mon bronzage', subtitle:'Souhaitez-vous préparer votre peau à l’exposition solaire ?', options:[o('yes','☀️','Oui'),o('no','🍃','Non')] },
    hydration:{ title:'Mon hydratation', subtitle:'Quand souhaitez-vous améliorer votre hydratation ?', options:[o('exercise','🏃','Pendant le sport'),o('heat','☀️','Par temps chaud'),o('daily','💧','Au quotidien')] },

    pollution:{ title:'Vivez-vous dans un environnement pollué ?', subtitle:'Cette information peut être utile pour certaines recommandations antioxydantes et de confort visuel.', options:[o('yes','🏙️','Oui'),o('no','🌿','Non'),o('unsure','○','Je ne sais pas')] },
    smoke:{ title:'Êtes-vous fumeur ?', subtitle:'Cette information peut influencer certaines recommandations de soutien général.', options:[o('yes','🚬','Oui'),o('no','✓','Non'),o('skip','○','Je préfère ne pas préciser')] },
    meat:{ title:'Consommez-vous de la viande ?', subtitle:'Cela nous aide à filtrer certaines recommandations.', options:[o('regular','🍽️','Oui, régulièrement'),o('sometimes','🥗','Occasionnellement'),o('no','🌱','Non')] },
    fish:{ title:'Consommez-vous du poisson ?', subtitle:'Cela nous aide notamment à éviter certaines recommandations marines si besoin.', options:[o('regular','🐟','Oui, régulièrement'),o('sometimes','🍽️','Occasionnellement'),o('no','🌱','Non')] },
    diet:{ title:'Avez-vous un régime alimentaire particulier ?', subtitle:'Sélectionnez ce qui vous correspond le mieux.', options:[o('mixed','🍽️','Aucun en particulier / omnivore'),o('vegetarian','🥗','Végétarien'),o('vegan','🌱','Végétalien'),o('pescatarian','🐟','Pescétarien'),o('other','○','Autre / je préfère ne pas préciser')] },
    allergies:{ title:'Avez-vous des allergies ?', subtitle:'Par précaution, certaines catégories de produits pourront être écartées.', type:'multi', max:5, options:[o('fish','🐟','Poisson / produits marins'),o('shellfish','🦐','Crustacés'),o('soy','🌱','Soja'),o('other','⚠️','Autres allergies'),o('none','✓','Aucune allergie connue'),o('skip','○','Je préfère ne pas répondre')] },
    pathologies:{ title:'Souffrez-vous d’une ou plusieurs des pathologies suivantes ?', subtitle:'Afin de vous proposer une routine 100% adaptée à vos besoins, nous souhaitons vous poser quelques questions concernant les contre-indications avec les produits. Ces réponses nous permettent de vous proposer les produits les mieux adaptés. Pas d’inquiétude, elles ne sont pas enregistrées.', type:'multi', max:18, options:[
      o('diabetes','⚕️','Diabète'),
      o('asthma','🌬️','Asthme'),
      o('hormonal_cancer','🩺','Cancer hormonodépendant'),
      o('cardio','❤️','Troubles cardiaques'),
      o('kidney','🧪','Insuffisance rénale'),
      o('blood_pressure','🫀','Hypertension artérielle'),
      o('thyroid','🦋','Troubles de la thyroïde'),
      o('ulcer','🫧','Ulcères gastroduodénaux'),
      o('mood','🧠','Troubles de l’humeur, du comportement ou de la personnalité'),
      o('depression','☁️','Dépression'),
      o('liver','🫙','Troubles du foie'),
      o('anticoagulant','💊','Prise d’un traitement anticoagulant'),
      o('autoimmune','🛡️','Maladies inflammatoires ou auto-immunes'),
      o('biliary','🧬','Troubles biliaires (calculs, obstruction etc)'),
      o('epilepsy','⚡','Épileptique'),
      o('glaucoma','👁️','Glaucome'),
      o('none','✓','Aucune'),
      o('skip','○','Je préfère ne pas répondre')
    ]}
  };

  const goalLabel = id => (goals.find(x=>x[0]===id)||[])[2] || '';
  const priorityOrder = ['skin','hair','immune','weight','digestion','joints','energy','stress','sleep','focus','heart','sport','beauty','women','eyes','hydration'];
  function path(){
    const a=['name','age','sex','goals'];
    const selected=Array.isArray(state.answers.goals)?[...state.answers.goals]:[];
    selected.sort((x,y)=>priorityOrder.indexOf(x)-priorityOrder.indexOf(y)).forEach(key=>{if(Q[key])a.push(key);});
    if(selected.includes('women') && state.answers.sex !== 'male') a.push('menopause');
    if(selected.includes('eyes')) a.push('screen_time');
    if(selected.some(x => ['skin','eyes','immune'].includes(x))) a.push('pollution');
    if(selected.some(x => ['heart','sleep','skin'].includes(x))) a.push('smoke');
    a.push('diet');
    if(['mixed','other'].includes(state.answers.diet)) a.push('meat','fish');
    if(['vegetarian','other'].includes(state.answers.diet)) a.push('fish');
    a.push('allergies','pathologies');
    return Array.from(new Set(a));
  }

  const matchers = {
    sport: [/cr[eé]atine|creatine|creatin|prot[eé]ine|protein|magn[eé]sium|magnesium|[eé]lectrolyte|electrolyte/i],
    energy: [/multivitamin|vitamine b12|vitamin b12|magn[eé]sium|magnesium|coenzyme q10|ubiquin|fer bisglycinate/i],
    stress: [/magn[eé]sium|magnesium|ashwagandha/i],
    women: [/magn[eé]sium|magnesium/i],
    skin: [/collag[eè]ne|collagen|biotine|biotin|zinc/i],
    hair: [/zinc|biotine|biotin|collag[eè]ne|collagen/i],
    focus: [/magn[eé]sium|magnesium|multivitamin/i],
    weight: [/konjac|psyllium|fibre/i],
    digestion: [/psyllium|spiruline|spirulina|probiot/i],
    eyes: [/multivitamin|z[eé]axanthine|zeaxanthin|lut[eé]ine|lutein/i],
    heart: [/coenzyme q10|ubiquin|omega/i],
    sleep: [/magn[eé]sium|magnesium|m[eé]latonine|melatonin/i],
    beauty: [/collag[eè]ne|collagen|biotine|biotin|acide hyaluronique|hyaluronic|zinc/i],
    immune: [/vitamine c|vitamin c|vitamine d3|vitamin d3|zinc|multivitamin/i],
    general: [/multivitamin|magn[eé]sium|magnesium|spiruline|spirulina|vitamine d3|vitamin d3/i],
    joints: [/collag[eè]ne|collagen|curcuma|curcumin|gingembre|ginger/i],
    hydration: [/[eé]lectrolyte|electrolyte|hydratation|hydration/i]
  };

  const escapeHTML = value => String(value ?? '').replace(/[&<>"']/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
  const money = cents => new Intl.NumberFormat(document.documentElement.lang || 'fr-FR', { style: 'currency', currency }).format((cents || 0) / 100);

  function setStep(label, frac) {
    stepLabel.textContent = label;
    progress.style.width = `${Math.max(0, Math.min(100, frac))}%`;
  }

  function buttons(left, right, rightDisabled = false) {
    footer.innerHTML = `<button class="plnd__btn plnd__btn--ghost" id="plnd-back" type="button">← Retour</button><button class="plnd__btn plnd__btn--primary" id="plnd-next" type="button" ${rightDisabled ? 'disabled' : ''}>${escapeHTML(right)} →</button>`;
    footer.querySelector('#plnd-back').addEventListener('click', left);
  }

  function intro() {
    setStep('Bienvenue', 0);
    screen.innerHTML = `
      <div class="plnd__inner">
        <section class="plnd__hero">
          <div class="plnd__hero-copy">
            <div class="plnd__eyebrow">Pure Lab Nutrition · votre bien-être</div>
            <h2>Trouvez votre routine <span class="plnd__accent">bien-être personnalisée</span></h2>
            <p>Répondez à quelques questions pour découvrir les compléments les plus adaptés à vos besoins, à votre profil et aux produits actuellement disponibles sur Pure Lab Nutrition.</p>
            <ul class="plnd__hero-points">
              <li>Rapide (2 minutes)</li>
              <li>100% personnalisé</li>
              <li>Jusqu’à 5 recommandations adaptées</li>
              <li>Sans engagement d’achat</li>
            </ul>
          </div>
          <div class="plnd__hero-side">
            <div class="plnd__hero-photo"><div class="plnd__hero-photo-badge">Pure Lab Nutrition</div></div>
            <div class="plnd__hero-side-card plnd__hero-side-card--primary">
              <span class="plnd__hero-kicker">Ce que vous allez obtenir</span>
              <div class="plnd__hero-metric">Une routine claire,<br>simple et cohérente.</div>
              <div class="plnd__hero-submetric">Vos réponses permettent d’orienter la sélection pour vous proposer une routine plus pertinente, tout en vous laissant le choix final.</div>
              <div class="plnd__mini-grid">
                <div class="plnd__mini-tile"><strong>Objectifs</strong><span>1 à 3 besoins sélectionnés</span></div>
                <div class="plnd__mini-tile"><strong>Profil</strong><span>Âge, habitudes et contexte</span></div>
                <div class="plnd__mini-tile"><strong>Résultats</strong><span>Jusqu’à 5 produits recommandés</span></div>
                <div class="plnd__mini-tile"><strong>Flexible</strong><span>Vous pouvez retirer des produits</span></div>
              </div>
            </div>
          </div>
        </section>
      </div>`;

    footer.innerHTML = `<span class="plnd__footnote">Sans engagement d’achat</span><button class="plnd__btn plnd__btn--primary" type="button" id="plnd-start">Commencer mon diagnostic →</button>`;
    footer.querySelector('#plnd-start').onclick = () => {
      state.index = 0;
      question();
    };
  }

  function question() {
    const ids = path();
    if (state.index >= ids.length) { email(); return; }
    const id = ids[state.index], q = Q[id];
    if (!q) { state.index++; question(); return; }
    const value = state.answers[id];
    const multi = q.type === 'multi';
    const selected = multi ? (Array.isArray(value) ? value : []) : [];
    setStep(`Étape ${state.index + 1} sur ${ids.length}`, Math.round(100 * (state.index + 1) / (ids.length + 1)));
    const isText = q.type === 'text';

    screen.innerHTML = `<div class="plnd__inner"><section class="plnd__question-shell plnd__content-card">
      <div class="plnd__question-intro"><div class="plnd__question-meta"><span class="plnd__pill">Votre profil</span><span class="plnd__pill">Étape ${state.index + 1}/${ids.length}</span></div>
      <div class="plnd__eyebrow">Diagnostic personnalisé</div>
      <h2>${escapeHTML(q.title)}</h2><p>${escapeHTML(q.subtitle || (multi ? 'Plusieurs réponses possibles.' : 'Sélectionnez la réponse qui vous correspond.'))}</p></div>
      ${isText ? `<label class="plnd__field"><span class="plnd__field-label">Quel est votre prénom ?</span><input class="plnd__email" id="plnd-name" maxlength="60" autocomplete="given-name" placeholder="Ex. : Julie" value="${escapeHTML(value || '')}"></label>` :
      `<div class="plnd__choices">${q.options.map(item => { const checked = multi ? selected.includes(item.id) : value === item.id; return `<button class="plnd__choice" type="button" data-value="${escapeHTML(item.id)}" aria-pressed="${checked}"><span class="plnd__choice-icon" aria-hidden="true">${escapeHTML(item.icon)}</span><span class="plnd__choice-copy"><strong>${escapeHTML(item.label)}</strong>${item.note ? `<span>${escapeHTML(item.note)}</span>` : ''}</span><span class="plnd__choice-check">${checked ? '✓' : ''}</span></button>`; }).join('')}</div>`}
      ${multi ? `<div class="plnd__selection-note">${selected.length} réponse${selected.length > 1 ? 's' : ''} sélectionnée${selected.length > 1 ? 's' : ''}${q.max ? ' · Maximum ' + q.max : ''}</div>` : ''}
    </section></div>`;

    buttons(() => { if (state.index === 0) intro(); else { state.index--; question(); } }, state.index === ids.length - 1 ? 'Continuer vers le mail' : 'Suivant', isText ? !String(value || '').trim() : multi ? !selected.length : !value);

    const next = footer.querySelector('#plnd-next');
    if (isText) {
      const input = screen.querySelector('#plnd-name');
      input.addEventListener('input', () => { state.answers.name = input.value.trim(); next.disabled = !state.answers.name; });
    } else {
      screen.querySelectorAll('.plnd__choice').forEach(btn => btn.onclick = () => {
        const v = btn.dataset.value;
        if (multi) {
          let arr = Array.isArray(state.answers[id]) ? [...state.answers[id]] : [];
          if (['none','skip'].includes(v)) {
            arr = [v];
          } else {
            arr = arr.filter(x => !['none','skip'].includes(x));
            if (arr.includes(v)) arr = arr.filter(x => x !== v);
            else if (arr.length < (q.max || 5)) arr.push(v);
          }
          state.answers[id] = arr;
        } else {
          state.answers[id] = v;
        }

        const vals = Array.isArray(state.answers[id]) ? state.answers[id] : [state.answers[id]];
        screen.querySelectorAll('.plnd__choice').forEach(el => {
          const isSelected = vals.includes(el.dataset.value);
          el.setAttribute('aria-pressed', String(isSelected));
          el.querySelector('.plnd__choice-check').textContent = isSelected ? '✓' : '';
        });
        const count = screen.querySelector('.plnd__selection-note');
        if (count) count.textContent = `${vals.length} réponse${vals.length > 1 ? 's' : ''} sélectionnée${vals.length > 1 ? 's' : ''}${q.max ? ' · Maximum ' + q.max : ''}`;
        next.disabled = vals.length === 0;
      });
    }

    next.onclick = () => {
      const val = state.answers[id];
      if (q.type === 'text' && !String(val || '').trim()) return;
      if (multi && !Array.isArray(val)) return;
      if (!multi && !val) return;
      state.index++;
      question();
    };
  }

  function email() {
    setStep('Vos résultats', 90);
    screen.innerHTML = `
      <div class="plnd__inner">
        <section class="plnd__email-layout">
          <div class="plnd__email-panel">
            <div class="plnd__email-illus">✉️</div>
            <span class="plnd__tag">Étape finale</span>
            <h2>Recevez vos résultats personnalisés</h2>
            <p>Indiquez votre e-mail et confirmez votre inscription pour accéder immédiatement à vos recommandations personnalisées.</p>
            <form id="plnd-email-form" class="plnd__field">
              <label for="plnd-email-input" class="plnd__field-label">Votre adresse email</label>
              <input class="plnd__email" id="plnd-email-input" type="email" autocomplete="email" placeholder="votre@email.com" value="${escapeHTML(state.email)}" required>
              <button type="button" class="plnd__consent-toggle" id="plnd-consent" role="checkbox" aria-checked="${state.answers.marketing_consent ? 'true' : 'false'}"><span class="plnd__consent-square" aria-hidden="true"></span><span class="plnd__checkbox-copy"><strong>Oui, je souhaite recevoir les conseils et offres Pure Lab Nutrition</strong><small>Désinscription possible à tout moment.</small></span></button>
              <p class="plnd__privacy-note">En continuant, vous reconnaissez avoir pris connaissance de notre <a href="/pages/confidentialite" target="_blank" rel="noopener">politique de confidentialité</a>.</p>
              <p id="plnd-email-error" class="plnd__error plnd__small" role="alert"></p>
            </form>
          </div>
          <aside class="plnd__email-side">
            <div class="plnd__eyebrow">Ce que vous allez obtenir</div>
            <ul class="plnd__benefit-list">
              <li>Votre routine personnalisée</li>
              <li>Jusqu’à 5 produits recommandés</li>
              <li>Des explications claires sur la logique de recommandation</li>
            </ul>
          </aside>
        </section>
      </div>`;

    buttons(() => {
      state.index = path().length - 1;
      question();
    }, 'Voir mes résultats', true);

    const input = screen.querySelector('#plnd-email-input');
    const consent = screen.querySelector('#plnd-consent');
    const error = screen.querySelector('#plnd-email-error');
    const next = footer.querySelector('#plnd-next');
    const form = screen.querySelector('#plnd-email-form');

    function validateEmailStep(showMessage = false) {
      const emailOk = input.checkValidity() && input.value.trim().length > 0;
      const consentOk = consent.getAttribute('aria-checked') === 'true';
      next.disabled = !(emailOk && consentOk);
      if (showMessage) {
        if (!emailOk) error.textContent = 'Veuillez renseigner une adresse e-mail valide.';
        else if (!consentOk) error.textContent = 'Veuillez cocher la case de consentement pour continuer.';
        else error.textContent = '';
      } else error.textContent = '';
      return emailOk && consentOk;
    }

    input.addEventListener('input', () => validateEmailStep(false));
    consent.addEventListener('click', () => {
      const newValue = consent.getAttribute('aria-checked') !== 'true';
      consent.setAttribute('aria-checked', String(newValue));
      state.answers.marketing_consent = newValue;
      validateEmailStep(false);
    });
    validateEmailStep(false);

    // Native Shopify form submission is necessary for Shopify hCaptcha.
    // Store the quiz temporarily in this tab so it can be restored after Shopify redirects.
    function submitToShopify(emailAddress) {
      const shopifyForm = document.getElementById('plnd-shopify-newsletter');
      if (!shopifyForm) throw new Error('Formulaire Shopify introuvable.');
      const emailField = shopifyForm.querySelector('[name="contact[email]"]');
      const tagsField = shopifyForm.querySelector('[name="contact[tags]"]');
      if (!emailField || !tagsField) throw new Error('Formulaire Shopify incomplet.');
      emailField.value = emailAddress;
      tagsField.value = 'newsletter, Diagnostic PLN';
      state.email = emailAddress;
      state.answers.marketing_consent = true;
      try {
        sessionStorage.setItem('plnd-pending-signup-v2', JSON.stringify({
          created: Date.now(), origin: location.pathname,
          email: emailAddress, name: state.name,
          index: state.index, answers: state.answers
        }));
      } catch (err) {
        throw new Error('Impossible de conserver votre diagnostic pendant la validation Shopify. Autorisez le stockage temporaire dans ce navigateur.');
      }
      // Shopify documents this API for forms submitted programmatically.
      // Never invoke hCaptcha directly or use fetch() to bypass the challenge.
      if (window.Shopify && window.Shopify.captcha && typeof window.Shopify.captcha.protect === 'function') {
        window.Shopify.captcha.protect(shopifyForm, () => shopifyForm.submit());
      } else {
        // A regular browser POST preserves Shopify's redirect/challenge handling.
        shopifyForm.requestSubmit();
      }
    }

    next.onclick = () => {
      if (!validateEmailStep(true)) return;
      form.requestSubmit();
    };

    let saving = false;
    form.onsubmit = e => {
      e.preventDefault();
      if (saving || !validateEmailStep(true)) return;
      saving = true;
      next.disabled = true;
      error.textContent = 'Validation auprès de Shopify…';
      try {
        submitToShopify(input.value.trim());
      } catch (err) {
        saving = false;
        validateEmailStep(false);
        error.textContent = err.message || 'Impossible de valider votre inscription pour le moment.';
      }
    };
  }

  function scoreProducts(products) {
    const targets = Array.isArray(state.answers.goals) ? state.answers.goals : [];
    const allergies = Array.isArray(state.answers.allergies) ? state.answers.allergies : [];
    const eligible = products.filter(p => {
      if (!p.available || !p.variant_id || p.price_cents <= 0 || p.diagnostic_exclude) return false;
      const t = `${p.title} ${p.type}`;
      if ((allergies.includes('fish') || allergies.includes('shellfish')) && /marin|marine|poisson|fish|crustac/i.test(t)) return false;
      if (state.answers.diet === 'vegan' && /marin|marine|poisson|fish|bovin|bovine|collag[eè]ne|collagen/i.test(t)) return false;
      if ((state.answers.fish === 'no' || state.answers.diet === 'vegetarian') && /marin|marine|poisson|fish/i.test(t)) return false;
      return true;
    });

    const ranking = eligible.map(p => {
      const title = `${p.title} ${p.type}`;
      let score = 0;
      const reasons = [];
      targets.forEach((g, i) => {
        const rx = matchers[g] || [];
        if (rx.some(re => re.test(title))) {
          score += i === 0 ? 10 : 6;
          reasons.push(`En lien avec ${goalLabel(g).toLowerCase()}`);
        }
      });

      const tagGoals = (Array.isArray(p.diagnostic_goals) ? p.diagnostic_goals.join(' ') : String(p.diagnostic_goals || '')).toLowerCase();
      targets.forEach((g, i) => {
        if (tagGoals.split(/[\s,;|]+/).includes(g)) {
          score += i === 0 ? 12 : 7;
          reasons.unshift(`Correspond à votre objectif ${goalLabel(g).toLowerCase()}`);
        }
      });

      if (state.answers.energy === 'busy' && /multivitamin|magn[eé]sium|magnesium|vitamine b12|vitamin b12|spiruline|spirulina/i.test(title)) score += 2;
      if (state.answers.sleep && Array.isArray(state.answers.sleep) && state.answers.sleep.some(x => ['fall','night','morning'].includes(x)) && /magn[eé]sium|magnesium|m[eé]latonine|melatonin/i.test(title)) score += 2;
      if (state.answers.women && Array.isArray(state.answers.women) && state.answers.women.some(x => ['premenstrual','cramps','period_fatigue'].includes(x)) && /magn[eé]sium|magnesium|fer|iron/i.test(title)) score += 2;

      if (/\bfer\b|iron|shilajit|ashwagandha|m[eé]latonine|melatonin|vitamine k2|vitamin k2|curcuma|curcumin|gingembre|ginger|konjac/i.test(title) && !tagGoals && !reasons.length) score = 0;
      const reason = reasons[0] || 'Correspondance générale avec votre profil';
      return { ...p, score, reason };
    }).filter(p => p.score > 0).sort((a, b) => b.score - a.score || a.title.localeCompare(b.title));

    const chosen = [];
    const families = new Set();
    for (const p of ranking) {
      const t = p.title.toLowerCase();
      let family = p.handle;
      if (/cr[eé]atine|creatine/.test(t)) family = 'creatine';
      else if (/magn[eé]sium|magnesium/.test(t)) family = 'magnesium';
      else if (/collag[eè]ne|collagen/.test(t)) family = 'collagen';
      else if (/multivitamin/.test(t)) family = 'multivitamin';
      else if (/vitamine d3|vitamin d3/.test(t)) family = 'vitamin-d';
      else if (/vitamine c|vitamin c/.test(t)) family = 'vitamin-c';
      else if (/zinc/.test(t)) family = 'zinc';
      if (families.has(family)) continue;
      families.add(family);
      chosen.push(p);
      if (chosen.length === 5) break;
    }
    return chosen;
  }

  async function loadProducts() {
    const base = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    // Prefer theme JSON view: exposes curated product metafields when available.
    // Fall back to Shopify's public products.json feed where the custom collection view is unavailable.
    const all = [];
    const seen = new Set();
    async function fetchCatalog(mode) {
      let page = 1, pages = 1;
      while (page <= pages && page <= 40) {
        const url = new URL(mode === 'theme' ? `${base}collections/all?view=pln-diagnostic&page=${page}` : `${base}products.json?limit=250&page=${page}`, location.origin);
        const response = await fetch(url, { credentials:'same-origin', headers:{ Accept:'application/json' } });
        if (!response.ok) throw Error(`Catalogue indisponible (HTTP ${response.status})`);
        const payload = await response.json();
        if (!Array.isArray(payload.products)) throw Error('Données produits manquantes');
        const batch=payload.products;
        for (const item of batch) {
          if (!item || seen.has(item.id)) continue;
          seen.add(item.id);
          let product;
          if (mode === 'theme') product = { ...item, price_cents:Number(item.price_cents)||0 };
          else {
            const variants=Array.isArray(item.variants)?item.variants:[];
            const v=variants.find(v=>v.available)||variants[0];
            if (!v) continue;
            const image=item.image?.src||item.images?.[0]?.src||null;
            product={id:item.id,title:item.title||'',handle:item.handle||'',url:`${base}products/${encodeURIComponent(item.handle||'')}`,type:item.product_type||'',tags:item.tags||[],image,available:variants.some(x=>x.available),variant_id:v.id,price_cents:Math.round(Number(v.price||0)*100),diagnostic_goals:'',diagnostic_exclude:false};
          }
          all.push(product);
        }
        pages=mode==='theme'?Number(payload.pages||1):(batch.length===250?page+1:page);
        page++;
        if (mode==='public' && batch.length<250) break;
      }
      if (!all.length) throw Error('Aucun produit publié dans le catalogue');
      return all;
    }
    try { return await fetchCatalog('theme'); }
    catch (e) { all.length=0;seen.clear();return await fetchCatalog('public'); }
  }

  async function results() {
    setStep('Vos recommandations', 100);
    screen.innerHTML = `<div class="plnd__loading"><div class="plnd__loading-spinner"></div><h2>Nous préparons votre sélection…</h2><p>Lecture du catalogue actuel Pure Lab Nutrition</p></div>`;
    footer.innerHTML = '';
    try {
      if (!state.products.length) state.products = await loadProducts();
      const medicalFlag = state.answers.age === 'minor' || (Array.isArray(state.answers.pathologies) && state.answers.pathologies.some(x => x !== 'none')) || (state.answers.allergies || []).some(x => x === 'other' || x === 'skip');
      state.recommended = scoreProducts(state.products);
      // For profiles requiring review, showcase goal-based options without presenting them as cleared for use.
      state.selected = new Set(state.recommended.map(p => p.id));
      drawResults(medicalFlag);
    } catch (e) {
      screen.innerHTML = `<div class="plnd__inner"><section class="plnd__state-card"><div class="plnd__eyebrow">Problème de chargement</div><h2>Le catalogue ne peut pas être chargé.</h2><p class="plnd__error">${escapeHTML(e.message)}</p><button class="plnd__retry" id="plnd-retry">Réessayer</button></section></div>`;
      screen.querySelector('#plnd-retry').onclick = () => { state.products = []; results(); };
      buttons(() => email(), 'Réessayer');
      footer.querySelector('#plnd-next').onclick = () => { state.products = []; results(); };
    }
  }

  function noResults(restricted) {
    screen.innerHTML = `<div class="plnd__inner"><section class="plnd__state-card"><div class="plnd__eyebrow">Votre profil</div><h2>Votre parcours personnalisé continue.</h2><p>Nous n’avons pas trouvé de correspondance assez précise dans les produits actuellement disponibles. Vous pouvez explorer notre catalogue ou ajuster vos objectifs.</p><div class="plnd__notice">Les sélections sont basées sur les produits disponibles. Aucune proposition ne doit être considérée comme un avis médical.</div><p style="margin-top:18px"><a href="/collections/all" target="_blank" rel="noopener">Explorer nos compléments →</a></p></section></div>`;
    buttons(() => email(), 'Modifier mes objectifs');
    footer.querySelector('#plnd-next').onclick = () => { state.index = Math.max(0, path().indexOf('goals')); question(); };
  }

  function drawResults(medicalFlag = false) {
    if (!state.recommended.length) {
      noResults(false);
      return;
    }

    const arr = state.recommended;
    const selectedGoals=Array.isArray(state.answers.goals)?state.answers.goals:[];
    const selectable = state.recommended.length;

    screen.innerHTML = `
      <div class="plnd__inner">
        <section class="plnd__result-shell">
          <div class="plnd__results-head">
            <div class="plnd__results-head-copy">
              <div class="plnd__eyebrow">Votre routine personnalisée</div>
              <h2>${escapeHTML(state.answers.name || 'Bonjour')}, découvrez vos résultats</h2>
              <p>${medicalFlag ? 'Votre sélection tient compte de vos objectifs. Une vérification de compatibilité est nécessaire avant utilisation.' : 'Votre sélection est prête : cochez ou décochez les produits selon vos envies.'}</p>
              ${medicalFlag ? '<div class="plnd__medical-note">Avant utilisation, vérifiez la compatibilité avec un professionnel de santé en cas de traitement, de pathologie ou d’allergie.</div>' : ''}
            </div>
            <div class="plnd__results-chips">
              <span class="plnd__pill">Objectifs&nbsp;: ${escapeHTML(selectedGoals.map(goalLabel).join(' · '))}</span>
              

            </div>
          </div>
          <div class="plnd__results-grid">
            <div class="plnd__products">${arr.map(p => `
              <label class="plnd__product ${state.selected.has(p.id) ? 'is-selected' : ''}">
                <div class="plnd__product-top">
                  <span class="plnd__product-badge">${escapeHTML(p.reason)}</span>
                  <span class="plnd__product-toggle"><input type="checkbox" data-product-id="${p.id}" ${state.selected.has(p.id) ? 'checked' : ''}> Sélectionner</span>
                </div>
                <div class="plnd__product-media">${p.image ? `<img src="${escapeHTML(p.image)}" loading="lazy" alt="${escapeHTML(p.title)}">` : '<div aria-hidden="true"></div>'}</div>
                <h3>${escapeHTML(p.title)}</h3>
                <p><strong>Pourquoi cette piste ?</strong> ${escapeHTML(p.reason)}.</p><a class="plnd__product-link" href="${escapeHTML(p.url)}" target="_blank" rel="noopener" onclick="event.stopPropagation()">Consulter la fiche produit →</a>
                <div class="plnd__product-price">${money(p.price_cents)}</div>
              </label>`).join('')}</div>
            <aside class="plnd__summary">
              <div class="plnd__total" id="plnd-total"></div><div class="plnd__browse-shell"><button type="button" class="plnd__btn plnd__btn--ghost plnd__browse-btn" id="plnd-browse">+ Ajouter un produit</button><div class="plnd__browse" id="plnd-browse-panel" hidden></div></div>
              
              ${medicalFlag ? '<div class="plnd__medical-note"><strong>Précaution :</strong> votre profil comporte une information nécessitant un avis professionnel. Ces suggestions ne confirment pas la compatibilité des produits avec votre situation.<label class="plnd__review-check"><input id="plnd-medical-ack" type="checkbox"> <span>Je comprends qu’une vérification auprès d’un professionnel de santé est nécessaire avant toute prise.</span></label></div>' : ''}

            </aside>
          </div>
        </section>
      </div>`;

    screen.querySelectorAll('[data-product-id]').forEach(chk => {
      chk.onchange = () => {
        const id = Number(chk.dataset.productId);
        if (chk.checked) state.selected.add(id);
        else state.selected.delete(id);
        chk.closest('.plnd__product').classList.toggle('is-selected', chk.checked);
        updateTotal();
        const panel = screen.querySelector('#plnd-browse-panel');
        if (panel && !panel.hidden) renderBrowse();
      };
    });

    footer.innerHTML = `<button type="button" class="plnd__btn plnd__btn--ghost" id="plnd-return">← Mes réponses</button><button type="button" class="plnd__btn plnd__btn--primary" id="plnd-add">Ajouter ma sélection au panier →</button>`;
    footer.querySelector('#plnd-return').onclick = () => email();
    footer.querySelector('#plnd-add').onclick = addToCart;
    const acknowledgement = screen.querySelector('#plnd-medical-ack');
    if (acknowledgement) acknowledgement.addEventListener('change', updateTotal);
    const browse = screen.querySelector('#plnd-browse');
    const panel = screen.querySelector('#plnd-browse-panel');
    browse.onclick = () => {
      panel.hidden = !panel.hidden;
      if (!panel.hidden) renderBrowse();
    };
    updateTotal();
  }

  function renderBrowse() {
    const panel = screen.querySelector('#plnd-browse-panel');
    if (!panel || panel.hidden) return;
    const filter = (panel.querySelector('#plnd-browse-search')?.value || '').toLowerCase();
    const selectedIDs = new Set(state.recommended.filter(p => state.selected.has(p.id)).map(p => String(p.id)));
    const allergies=Array.isArray(state.answers.allergies)?state.answers.allergies:[];
    const available = state.products.filter(p => {
      if (!p.available || !p.variant_id || p.price_cents <= 0 || p.diagnostic_exclude || selectedIDs.has(String(p.id))) return false;
      const name = `${p.title} ${p.type}`;
      if (filter && !name.toLowerCase().includes(filter)) return false;
      if ((allergies.includes('fish') || allergies.includes('shellfish')) && /marin|marine|poisson|fish|crustac/i.test(name)) return false;
      if (state.answers.diet === 'vegan' && /marin|marine|poisson|fish|bovin|bovine|collag[eè]ne|collagen/i.test(name)) return false;
      return true;
    }).slice(0, 24);
    const inputValue = panel.querySelector('#plnd-browse-search')?.value || '';
    panel.innerHTML = `<label class="plnd__field-label" for="plnd-browse-search">Chercher un complément</label><input class="plnd__email plnd__browse-input" id="plnd-browse-search" value="${escapeHTML(inputValue)}" placeholder="Nom du produit…" autocomplete="off"><div class="plnd__browse-list">${available.map(p => `<div class="plnd__browse-item"><span>${escapeHTML(p.title)} <small>${money(p.price_cents)}</small></span><button class="plnd__browse-add" type="button" data-browse-id="${escapeHTML(String(p.id))}" ${state.selected.size >= 5 ? 'disabled' : ''}>+ Ajouter</button></div>`).join('') || '<p class="plnd__small">Aucun autre produit correspondant.</p>'}</div><p class="plnd__small">5 produits maximum dans la sélection.</p>`;
    const input = panel.querySelector('#plnd-browse-search');
    input.addEventListener('input', () => { const start=input.selectionStart; renderBrowse(); const next=panel.querySelector('#plnd-browse-search'); next.focus(); next.setSelectionRange(start,start); });
    panel.querySelectorAll('[data-browse-id]').forEach(button => button.onclick = () => {
      if (state.selected.size >= 5) return;
      state.recommended = state.recommended.filter(p => state.selected.has(p.id));
      const item = available.find(p => String(p.id) === button.dataset.browseId);
      if (!item) return;
      state.recommended.push({...item, reason:'Produit ajouté à votre sélection'});
      state.selected.add(item.id);
      const reviewRequired = !!screen.querySelector('#plnd-medical-ack');
      drawResults(reviewRequired);
      const newPanel=screen.querySelector('#plnd-browse-panel');
      if(newPanel){newPanel.hidden=false;renderBrowse();}
    });
  }

  function updateTotal() {
    const active = state.recommended.filter(p => state.selected.has(p.id));
    const subtotal = active.reduce((sum, p) => sum + p.price_cents, 0);
    const rate = active.length >= 3 ? 10 : (active.length >= 2 ? 5 : 0);
    const estimatedSavings = Math.round(subtotal * rate / 100);
    const estimatedTotal = subtotal - estimatedSavings;
    screen.querySelector('#plnd-total').innerHTML = `
      <div class="plnd__summary-heading"><span>Votre sélection</span><strong>${active.length}/5 produits</strong></div>
      ${rate ? `<div class="plnd__discount-highlight"><strong>−${rate} %</strong><span>de remise dès ${rate === 10 ? '3' : '2'} produits*</span></div>` : '<div class="plnd__discount-next">Encore 1 produit pour profiter de −5 %*</div>'}
      <div class="plnd__total-row"><span>Sous-total</span><span>${money(subtotal)}</span></div>
      ${rate ? `<div class="plnd__total-row plnd__savings"><span>Économie estimée</span><strong>−${money(estimatedSavings)}</strong></div><div class="plnd__total-row plnd__estimated"><b>Total estimé*</b><strong>${money(estimatedTotal)}</strong></div>` : `<div class="plnd__total-row plnd__estimated"><b>Total</b><strong>${money(subtotal)}</strong></div>`}
      <p class="plnd__discount-footnote">*Estimation indicative, sous réserve d’éligibilité. Seul le panier Shopify confirme les remises applicables.</p>`;

    const reviewRequired = !!screen.querySelector('#plnd-medical-ack');
    const reviewed = !reviewRequired || screen.querySelector('#plnd-medical-ack').checked;
    footer.querySelector('#plnd-add').disabled = !active.length || !reviewed;
    footer.querySelector('#plnd-add').textContent = `Ajouter ${active.length} produit${active.length > 1 ? 's' : ''} au panier →`;
    if (reviewRequired && !reviewed) footer.querySelector('#plnd-add').title = 'Confirmez la précaution avant de poursuivre';
  }

  async function addToCart() {
    const btn = footer.querySelector('#plnd-add');
    if (!btn || btn.disabled) return;
    btn.disabled = true;
    btn.textContent = 'Ajout en cours…';

    try {
      const items = state.recommended
        .filter(p => state.selected.has(p.id))
        .map(p => ({ id: Number(p.variant_id), quantity: 1, properties: { '_Origine': 'Diagnostic Pure Lab Nutrition' } }));

      const base = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
      const response = await fetch(base + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items })
      });
      const data = await response.json();
      if (!response.ok) throw Error(data.description || data.message || 'Ajout au panier impossible');

      close();
      document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { source: 'pln-diagnostic' } }));
      document.dispatchEvent(new CustomEvent('cart:updated', { detail: { source: 'pln-diagnostic' } }));
      window.location.assign(base + 'cart');
    } catch (e) {
      btn.disabled = false;
      btn.textContent = 'Réessayer l’ajout au panier →';
      alert(e.message);
    }
  }

  function open() {
    if (!root.hidden) return;
    state.previousFocus = document.activeElement;
    root.hidden = false;
    root.setAttribute('aria-hidden', 'false');
    document.body.classList.add('plnd--open');
    root.querySelector('.plnd__panel').focus();
    intro();
  }

  function close() {
    root.hidden = true;
    root.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('plnd--open');
    state.previousFocus?.focus?.();
  }

  root.querySelector('[data-plnd-close]').addEventListener('click', close);

  document.addEventListener('click', event => {
    const btn = event.target.closest('[data-pln-diagnostic-open],a[href="#diagnostic-pln"],a[href="#diagnostic-personnalise"]');
    if (btn) {
      event.preventDefault();
      open();
    }
  });

  document.addEventListener('keydown', event => {
    if (root.hidden) return;
    if (event.key === 'Escape') {
      event.preventDefault();
      close();
      return;
    }
    if (event.key === 'Tab') {
      const focusables = Array.from(root.querySelectorAll('button:not(:disabled),input:not(:disabled),a[href]')).filter(x => x.getClientRects().length);
      if (!focusables.length) return;
      const first = focusables[0];
      const last = focusables.at(-1);
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    }
  });

  // Shopify reloads the page following a native newsletter POST. Resume results only
  // when the server confirmed success; on rejection return to the e-mail step.
  (function resumeAfterShopify() {
    let pending;
    try {
      const raw = sessionStorage.getItem('plnd-pending-signup-v2');
      if (!raw) return;
      pending = JSON.parse(raw);
      sessionStorage.removeItem('plnd-pending-signup-v2');
    } catch (_) { return; }
    if (!pending || Date.now() - pending.created > 10 * 60 * 1000) return;
    // Other pages can render this snippet. Avoid reopening the popup on an unrelated page.
    if (pending.origin !== location.pathname) return;
    state.answers = pending.answers || {};
    state.name = pending.name || '';
    state.email = pending.email || '';
    state.index = pending.index || 0;
    const nativeForm = document.getElementById('plnd-shopify-newsletter');
    const resultStatus = nativeForm && nativeForm.querySelector('[data-plnd-signup-success]') ? 'success' : 'unknown';
    const url = new URL(location.href);
    const confirmed = resultStatus === 'success' || url.searchParams.get('customer_posted') === 'true';
    open();
    if (confirmed) {
      // Remove the status query so refreshing won't repeat the same state.
      url.searchParams.delete('customer_posted');
      try { history.replaceState(null, '', url.pathname + url.search + url.hash); } catch (_) {}
      results();
    } else {
      email();
      const message = document.getElementById('plnd-email-error');
      if (message) message.textContent = 'Shopify n’a pas validé votre inscription. Vérifiez votre adresse et réessayez. Si un contrôle anti-spam apparaît, terminez-le avant de poursuivre.';
    }
  })();

  window.PLNDiagnostic = { open, close };
})();
